import React, { forwardRef, ForwardRefRenderFunction } from "react";
//#region types
import { DimensionInputsViewProps } from "models/propTypes/dimensionPropTypes";
import { FormEnums } from "models/enums";
import { CurrencyFieldExtraProps, NumberFormatFieldExtraProps, FormHandles } from "models/propTypes/genericFormProps";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
import { DimensionFormTypes } from "models/formTypes";
//#endregion
//#region components
import GenericForm from "../forms/genericForm";
//#endregion

const DimensionInputs: ForwardRefRenderFunction<FormHandles, DimensionInputsViewProps> = (props, ref) => {
  return (
    <GenericForm<DimensionFormTypes.SplitInfo>
      formRef={ref}
      {...props}
      fields={{
        amount: {
          label: "",
          type: FormEnums.FormFieldType.HORIONTALFIELDGROUP,
          innerFields: {
            amount: {
              label: TranslationKeys.Common.Amount,
              type: FormEnums.FormFieldType.CURRENCY,
              icon: IconDefinitionConstants.WCalculator,
              widthColumnCount: 7,
              extraProps: {
                currency: props.currency,
              } as CurrencyFieldExtraProps<DimensionFormTypes.SplitInfo>,
              onChangeHandler: props.onAmountChange,
            },
            percentage: {
              label: TranslationKeys.Common.Share,
              type: FormEnums.FormFieldType.NUMBER,
              icon: IconDefinitionConstants.WSplitSection,
              widthColumnCount: 5,
              extraProps: {
                decimalPoints: 2,
                suffix: "%",
              } as NumberFormatFieldExtraProps,
              onChangeHandler: props.onPercentageChange,
            },
          },
        },
      }}
      hideErrorBubble
      hideSuccess
    />
  );
};

export default forwardRef(DimensionInputs);
